import styled, { css } from "styled-components";
import { type TypographyProps, type SpaceProps, color, space } from "styled-system";
import { type ThemeTypedColorProps, getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

type TextType = { lineThrough?: boolean; isLarge?: boolean; isSmall?: boolean } & ThemeTypedColorProps &
    TypographyProps &
    SpaceProps;

type PricesWrapperType = {
    hasSecondaryPrice?: boolean;
};
export const PricesWrapper = styled.div<PricesWrapperType>`
    white-space: nowrap;
    ${({ hasSecondaryPrice }) =>
        hasSecondaryPrice &&
        css`
            display: flex;
            flex-direction: column;
        `};
`;

export const Text = styled.div<TextType>`
    display: inline-block;
    line-height: 1;
    cursor: default;
    ${({ isSmall }) =>
        isSmall &&
        css`
            display: block;
        `};
    ${space};
    ${color};

    span {
        display: block;
        font-family: Arial, sans-serif;
        font-size: 1.4rem;
        line-height: 2rem;
        color: ${theme.colors.steel};

        @media ${getBreakpoint("up", "xl")} {
            font-size: 1.6rem;
        }
    }

    span:not(:first-child):nth-last-child(1) {
        font-size: 1.6rem;
        line-height: 2.4rem;
        color: ${theme.colors.azure};

        @media ${getBreakpoint("up", "xl")} {
            font-size: 1.8rem;
        }
    }
`;

export const SpanText = styled.div`
    white-space: nowrap;
`;

export const TextLineThrough = styled(Text)`
    text-decoration: line-through;
    color: ${theme.colors.titanium};
`;
